export default __webpack_public_path__ + "static/media/e.0bfdbf93.jpg";